<div class="dialog-header">
    <h2>Document Viewer</h2>
    <button class="dialog-close" (click)="close()">✖</button>
</div>

<div class="dialog-content">
    <ng-container *ngIf="checkFile(fileUrl); else fallback">
        <iframe [src]="getSafeUrl(fileUrl)" width="100%" height="100%"></iframe>
    </ng-container>
    <ng-template #fallback>
        <div class="text-center p-4">
            <p>This file type is not supported for preview.</p>
            <a [href]="fileUrl" target="_blank" rel="noopener" class="mat-raised-button color-primary">
            Download File
            </a>
        </div>
    </ng-template>    
</div>